import { useEffect, useState } from 'react'
import { api } from '../api.js'

const FILTRES = [
  ['open', 'En cours'], ['hot', 'Prioritaires'], ['all', 'Tous'], ['closed', 'Clôturés'],
]

export default function Dossiers({ onOuvrir, onContexte }) {
  const [choisis, setChoisis] = useState([])
  const [actions, setActions] = useState([])
  const [enCours, setEnCours] = useState(false)
  const [motif, setMotif] = useState(null)
  const [message, setMessage] = useState('')
  const [filtre, setFiltre] = useState('open')
  const [q, setQ] = useState('')
  const [liste, setListe] = useState([])

  useEffect(() => {
    const t = setTimeout(() => api.requests(filtre, q).then(setListe).catch(() => setListe([])), 150)
    return () => clearTimeout(t)
  }, [filtre, q])

  return (
    <>
      <h1>Dossiers</h1>
      <p className="chapo">Chaque dossier suit le circuit attaché à sa démarche. Ouvrez-en un pour
        voir les boutons dont vous disposez.</p>

      <div class="barre">
        <div className="onglets" role="tablist">
          {FILTRES.map(([id, label]) => (
            <button key={id} role="tab" aria-selected={filtre === id}
                    className={filtre === id ? 'on' : ''} onClick={() => setFiltre(id)}>{label}</button>
          ))}
        </div>
        <input type="search" value={q} onChange={(e) => setQ(e.target.value)}
               placeholder="Rechercher un nom, un numéro…" aria-label="Rechercher" />
      </div>

      {/* Sur ordinateur, un tableau dense. Sur mobile, des cartes tapables :
          l'agent de terrain doit ouvrir un dossier d'un pouce. */}
      {message && <p className="succes" role="status">{message}</p>}

      {choisis.length > 0 && (
        <div className="barre-selection" role="region" aria-label="Actions groupées">
          <strong>{choisis.length} dossier{choisis.length > 1 ? 's' : ''} sélectionné{choisis.length > 1 ? 's' : ''}</strong>
          {actions.map((a) => (
            <button key={a.id} disabled={enCours}
                    className={`btn sm ${a.tone === 'dgr' ? 'dgr' : 'pri'}`}
                    onClick={() => (a.require_comment ? setMotif(a) : lancer(a))}>
              {a.label}
            </button>
          ))}
          {!actions.length && (
            <span className="aide">Ces dossiers ne sont pas à la même étape : aucune action
              ne leur est commune.</span>
          )}
          <div className="pousse" />
          <button className="btn sm" onClick={() => setChoisis([])}>Tout désélectionner</button>
        </div>
      )}

      <table className="tableau sur-ordinateur">
        <thead>
          <tr>
            <th className="colonne-case">
              <input type="checkbox" aria-label="Tout sélectionner"
                     checked={choisis.length > 0 && choisis.length === liste.length}
                     onChange={(e) => setChoisis(e.target.checked ? liste.map((r) => r.id) : [])} />
            </th>
            <th>Numéro</th><th>Démarche</th><th>Demandeur</th><th>Étape</th><th>Mise à jour</th>
          </tr>
        </thead>
        <tbody>
          {liste.map((r) => (
            <tr key={r.id} tabIndex={0} className={choisis.includes(r.id) ? 'choisi' : ''}
                onClick={() => onOuvrir(r.id)}
                onKeyDown={(e) => e.key === 'Enter' && onOuvrir(r.id)}>
              <td className="colonne-case" onClick={(e) => e.stopPropagation()}>
                <input type="checkbox" checked={choisis.includes(r.id)}
                       aria-label={`Sélectionner ${r.number}`}
                       onChange={() => bascule(r.id)} />
              </td>
              <td className="mono">
                {r.criticity !== 'normal' && <span className={`pastille ${r.criticity}`} title="Prioritaire" />}
                {r.number}
              </td>
              <td><strong>{r.title}</strong>
                {r.awaiting && <span className="attente">réponse attendue de l'habitant</span>}</td>
              <td>{r.applicant?.name}</td>
              <td><span className={`etat ${r.tone}`}>{r.status}</span></td>
              <td className="mono">{new Date(r.updated_at).toLocaleDateString('fr-FR')}</td>
            </tr>
          ))}
          {!liste.length && <tr><td colSpan={6} className="vide">Aucun dossier ici.</td></tr>}
        </tbody>
      </table>

      <ul className="cartes-dossiers sur-mobile">
        {liste.map((r) => (
          <li key={r.id}>
            <button onClick={() => onOuvrir(r.id)}>
              <span className="haut">
                <span className="mono num">
                  {r.criticity !== 'normal' && <span className={`pastille ${r.criticity}`} />}
                  {r.number}
                </span>
                <span className={`etat ${r.tone}`}>{r.status}</span>
              </span>
              <strong>{r.title}</strong>
              <span className="bas">
                <span>{r.applicant?.name}</span>
                <span className="mono">{new Date(r.updated_at).toLocaleDateString('fr-FR')}</span>
              </span>
              {r.awaiting && <span className="attente">réponse attendue de l'habitant</span>}
            </button>
          </li>
        ))}
        {!liste.length && <li className="vide">Aucun dossier ici.</li>}
      </ul>
      {motif && (
        <div className="fenetre" role="dialog" aria-label="Motif">
          <div className="fenetre-corps">
            <h2>{motif.label}</h2>
            <p className="aide">Ce motif sera inscrit sur les {choisis.length} dossiers et,
              selon le circuit, communiqué aux habitants.</p>
            <div className="champ">
              <label htmlFor="lot-motif">Motif</label>
              <textarea id="lot-motif" rows={3} autoFocus
                        onChange={(e) => setMotif({ ...motif, texte: e.target.value })} />
            </div>
            <div className="ligne separee">
              <div className="pousse" />
              <button className="btn" onClick={() => setMotif(null)}>Annuler</button>
              <button className="btn pri" disabled={!motif.texte?.trim() || enCours}
                      onClick={() => lancer(motif, motif.texte.trim())}>
                Appliquer aux {choisis.length} dossiers
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
